import memoize from 'lodash/memoize';
import { validateURL } from '../../domains/identity';
import { EOrgAccess, IUserRole } from '../../domains/identity/types';

export function redirect(url: string) {
  if (!validateURL(url)) return;

  window.open(encodeURI(url), '_blank', 'noopener');
}

export const generateUserRoleData: (roles: IUserRole[]) => {
  organizationRole: EOrgAccess;
  appRoles: { [tenantId: string]: string };
} = (roles) => {
  const organizationRole = roles.length
    ? EOrgAccess[
        //@ts-ignore
        roles.find((role) => role.scope === 'Organization')
          .role as keyof typeof EOrgAccess
      ]
    : EOrgAccess['Organization User'];

  const appRoles = roles
    .filter((role) => role.scope !== 'Organization')
    .reduce((acc, { tenantId, role }) => {
      const tenantEntry = tenantId && role ? { [tenantId]: role } : {};

      return { ...acc, ...tenantEntry };
    }, {});

  return { organizationRole, appRoles };
};

export const generateRoleDataMemoised = memoize(generateUserRoleData);
